import React from 'react';
import s from '../styles/ReportDetails.module.css';

const LastReportViewer = ({ lastReport }) => {
  if (!lastReport) {
    return (
      <div className={s.result_all}>
        <p className={s.no_data}>Нет данных о последнем отчёте.</p>
      </div>
    );
  }

  const startTime = lastReport.started_at
    ? new Date(lastReport.started_at).toLocaleString()
    : 'Неизвестно';

  return (
    <div className={s.result_all}>
      <div className={s.time_div}>
        <p className={s.time_p}>Начало:</p>
        <p className={s.time_p_value}>{startTime}</p>
      </div>
      <div className={s.time_div}>
        <p className={s.time_p}>Статус:</p>
        <p className={s.time_p_value}> {lastReport.status}</p>
      </div>
      <div className={s.time_div}>
      {lastReport.stats?.count && (
        <>
      <p className={s.time_p}>Всего объявлений:</p>
       <p className={s.time_p_value}>{lastReport.stats.count}</p>
        </>
      )}
      </div>

      {lastReport.stats?.sections?.length > 0 && (
        <div className={s.report_detail_div}>
          {lastReport.stats.sections.map((section, idx) => {
            let className = '';

            if (section.slug === 'successful') {
              className = s.success;
            } else if (section.slug === 'publish_with_problems') {
              className = s.ispublish_with_error;
            } else {
              className = s.error_items;
            }

            return (
              <details key={idx} className={className}>
                <summary>
                  {section.title}:{' '}
                  <span className={s.count}>{section.count}</span>
                </summary>

                {section.sections?.length > 0 && (
                  <ul className={s.ul}>
                    {section.sections.map((sub, i) => (
                      <li key={i}>
                        {sub.title}:{' '}
                        <span className={s.count}>{sub.count}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </details>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LastReportViewer;